import { BehaviorSubject, Subscription } from "rxjs";
import { EmailRecipient } from "./email.model";
import { City } from "../city/city.model";
import { Venue } from "../venue/venue.model";

export class EmailRecipientFilterService {
  public filtered$: BehaviorSubject<EmailRecipient[]> = new BehaviorSubject<
    EmailRecipient[]
  >([]);

  public recipients: EmailRecipient[];
  public filtered: EmailRecipient[] = [];
  public subscription: Subscription;
  public currentCity: City = null;
  public currentVenue: Venue = null;
  public searchText: string = "";

  itemsPerPage: number[] = [10, 20, 50];
  showing: number = 10;
  firstIndex: number = 0;
  lastIndex: number = 0 + this.showing;
  constructor() {
    this.subscribe();
  }

  next(recipients: EmailRecipient[]) {
    this.filtered$.next(recipients);
  }
  reset() {
    this.currentCity = null;
    this.currentVenue = null;
    this.searchText = "";
    this.firstIndex = 0;
    this.lastIndex = this.showing;
  }
  unsubscribe() {
    if (this.subscription != null) this.subscription.unsubscribe();
  }

  subscribe() {
    this.subscription = this.filtered$.subscribe(async recipients => {
      this.recipients = recipients;
      if (this.filtered == null || this.filtered.length == 0)
        this.filtered = recipients;
      this.filter();
    });
  }

  search(text: string) {
    this.searchText = text;
    this.filter();
  }

  filter() {
    this.filtered = this.recipients.filter(recipient =>
      this.shouldFilter(recipient)
    );
  }

  shouldFilter(recipient: EmailRecipient) {
    var isNullVenue = this.currentVenue == null;
    var isNullCity = this.currentCity == null;

    var isAuthorizedVenue = !isNullVenue && 
    recipient.venues != null &&
      recipient.venues.includes(this.currentVenue.path);

    var isAuthorizedCity =
      isNullCity ||
      (recipient.cities != null &&
        recipient.cities.includes(this.currentCity.reference.path));

    var isAuthorized = isAuthorizedCity || isAuthorizedVenue;

    // var venueFlag: boolean =
    //   this.currentVenue == null ||
    //   recipient.hasFullAccess ||
    //   (recipient.venues != null &&
    //     recipient.venues.includes(this.currentVenue.path));

    // var cityFlag: boolean =
    //   this.currentCity == null ||
    //   recipient.hasFullAccess ||
    //   (recipient.cities != null &&
    //     recipient.cities.includes(this.currentCity.reference.path));

    var searchFlag: boolean =
      this.searchText == "" ||
      recipient.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
      recipient.email.toLowerCase().includes(this.searchText.toLowerCase());

    return isAuthorized && searchFlag;
  }

  setItemsPerPage(item: number) {
    this.showing = item;
    this.firstIndex = 0;
    this.lastIndex = item;
  }

  show(i: number) {
    return i >= this.firstIndex && i < this.lastIndex;
  }

  increment() {
    if (this.lastIndex <= this.filtered.length) {
      this.firstIndex += this.showing;
      this.lastIndex += this.showing;
    }
  }
  decrement() {
    if (this.firstIndex - this.showing >= 0) {
      this.firstIndex -= this.showing;
      this.lastIndex -= this.showing;
    }
  }
}
